import "./contact-section.scss";
import React from "react";
import ContactDetails from "components/ContactDetails";
import ContactFormSection from "components/ContactFormSection";
import classNames from "classnames";

const ContactSection = ({ media, contact, sponsors, className, lang }) => {
  return (
    <section className={classNames(className, `contact-section`)}>
      <div className="container">
        <div className="row">
          <div className="col-lg-5">
            <div className="contact-section__left-content">
              <ContactDetails
                media={media}
                sponsors={sponsors}
                contact={contact}
                lang={lang}
              />
            </div>
          </div>
          <div className="col-lg-7">
            <ContactFormSection lang={lang} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
